module.exports = __webpack_public_path__ + "media/images/book-80f21f34207224c1281f001d1762bf94.svg";